<template lang="pug" id="CalHeatmap">
extends ./Base.pug
</template>


<script>
import CalHeatmap from 'cal-heatmap';
import 'cal-heatmap/cal-heatmap.css';
import Tooltip from 'cal-heatmap/plugins/Tooltip';
import Legend from 'cal-heatmap/plugins/Legend';
import BaseChart from '@/localPlugins/charts/Base.vue';
import isEmpty from 'lodash/isEmpty';
import dayjs from '@/localPlugins/dayjs';
import { min, max } from 'lodash';

const DEFAULT_COLOR_MAX = 100;
const DEFAULT_COLOR_MIN = 0;

export default {
  extends: BaseChart,
  name: 'aiqCalHeatmap',
  beforeUnmount() {
    if (this.calchart) {
      this.calchart.destroy();
    }
  },
  methods: {
    getChartType() {
      return 'CalHeatmap';
    },
    next(e) {
      e.preventDefault();
      this.calchart.next();
    },
    previous(e) {
      e.preventDefault();
      this.calchart.previous();
    },
    dataValues() {
      return this.report;
    },
    deriveStartDate(datapoints) {
      return new Date(datapoints[0].time_epoch);
    },
    deriveRange(datapoints) {
      if (isEmpty(datapoints)) {
        return 1;
      }
      const first = dayjs(datapoints[0].time_epoch);
      const last = dayjs(datapoints.slice(-1)[0].time_epoch);
      return last.diff(first, 'months') + 1;
    },
    deriveMinMax(datapoints) {
      if (isEmpty(datapoints)) {
        return [DEFAULT_COLOR_MIN, DEFAULT_COLOR_MAX];
      }
      const values = datapoints.map(dp => dp.num_conversations);
      return [min(values), max(values)];
    },
    renderChart() {
      if (this.calchart) {
        this.calchart.destroy();
      }
      this.calchart = new CalHeatmap();
      this.calchart.paint({
        itemSelector: this.$el.querySelector('.chart-container'),
        data: {
          source: this.dataValues(),
          x: this.graphParams.x,
          y: this.graphParams.y,
        },
        verticalOrientation: this.graphParams.verticalOrientation,
        range: this.graphParams.range,
        date: { start: this.deriveStartDate(this.dataValues()) },
        scale: {
          color: {...this.graphParams.color,
            domain: this.deriveMinMax(this.dataValues()),
          },
        },
        domain: this.graphParams.domain,
        subDomain: this.graphParams.subdomain,
      },
      [
        [
          Tooltip,
          this.graphParams.TooltipConfig,
        ],
      ],
      [[Legend, this.graphParams.LegendConfig]],
      );

    },
  },

};
</script>
<style lang="scss" scoped>
  @import "@/styles/aiq-mixins.scss";
  @import "@/styles/aiq-variables.scss";
.chart-container {
  height: auto;
  width: 100%;
  display: flex;
  justify-content: center; /* Centers horizontally */
  align-items: center; /* Centers vertically */
}
.legend-container {
  display: none;
}
#nav-buttons {
  display: flex;
  justify-content: center; /* Centers horizontally */
  align-items: end; /* Centers vertically */
  margin: 30px;
}

// Custom styles for cal-heatmap
:deep(.ch-domain-text) {
  font-size: 16px !important;
  font-weight: 600;
}

:deep(.ch-label) {
  font-size: 12px !important;
  font-weight: 500;
}

// Ensure day labels are displayed horizontally at the top
:deep(.ch-calendar) {
  .ch-label {
    text-anchor: start !important;
    dominant-baseline: hanging !important;
  }
}
</style>
